import { default_pods_input_state_smart_get, virtel_schema_smart_get } from "./ter-virtel-definition-lib";
import { _get_fixed_fields } from "./ter-virtel-utils";
import { _getParamsFromLib } from "./ter-params-utils";
import { protobomp_manipulator } from "../utils/frfr-protobomp-utils";
import { terProtobompUtils_make_protobomp_manifest_terkk_latest } from "./ter-protobomp-utils";


// TER DRAFTEL CODECS LIB

/*
// PPGRUPA VENTILATORI ali za sada idu odvojeno PPV i Nosač ventilatora
nosacventilatora u izradi

TODO:
- 

*/


export const draftel_codecs_pack_terkk$_bundle_nosacventilatora = {};


// ---------- CODEC SCHEMA METHODS ----------


draftel_codecs_pack_terkk$_bundle_nosacventilatora.default_preset_state = () => {
  const preset_state = {
    _draftelschemakey: 'terkk$_bundle_nosacventilatora',
    terkknivo: 'CHILDOFMODUL', // ???
    // ID polje ne ide u preset, dobija se samo u EDIT MODE ali i tada mora biti obezbedjeno

    _subform_arr: [], // SUBFORM ARR

    _protobomp: protobomp_manipulator.init(terProtobompUtils_make_protobomp_manifest_terkk_latest("terkk$ppvnosacv"), null),

    "flag_custom_pods_input": false, // flag_custom_pods_input is false by default

    // pods_input za bundle nepotreban jer se koristi widget za pods_input

    ppv_vent_nanosacu: "", // NOVO 2023-08-22
    ppv_brojventilatora: 0,
    ppvnosacv_smermontaze: 0,
    ppvnosacv_precnikotvora: 0,
    ppvnosacv_duzinanosacal: 0,
    ppvnosacv_l2: 0,
    ppvnosacv_l3: 0,

    kolicina: 1,

    ppvnosacv_materijal_lim: null,
    ppvnosacv_materijal_lim_maska_unp: null,
    ppvnosacv_materijal_profil_unp_bezdimenzioni: null,
  };
  return preset_state;
};


draftel_codecs_pack_terkk$_bundle_nosacventilatora.default_pods_input_state = () => {
  /*
  return {

  };
  */
  return default_pods_input_state_smart_get('terkk$nosacventilatora');
};


draftel_codecs_pack_terkk$_bundle_nosacventilatora.default_subform_item_preset_state = () => {
  const preset_state = {
    _draftelschemakey: 'terkk$_bundle_nosacventilatora_subform_item',
    terkknivo: 'CHILDOFMODUL', // ???
    // ID polje ne ide u preset, dobija se samo u EDIT MODE ali i tada mora biti obezbedjeno

    "flag_custom_pods_input": false, // flag_custom_pods_input is false by default


    kolicina: 1,
  };
  return preset_state;
};


draftel_codecs_pack_terkk$_bundle_nosacventilatora.keys_for_direct_cloning = [
  "flag_custom_pods_input",

  // pods_input 

  ...Object.keys(draftel_codecs_pack_terkk$_bundle_nosacventilatora.default_pods_input_state()),

  "rev_id",
  "superkey",
  "subkey",
  "parent_subkey",
  ...Object.keys(draftel_codecs_pack_terkk$_bundle_nosacventilatora.default_subform_item_preset_state())
];


/////////


// ---------- CODEC ENCODING  - DRAFTEL TO VIRBOM DIRECTION ----------




// ---------- CODEC DECODING - VIRBOM TO DRAFTEL DIRECTION ----------
// ZA NOVE POLUPROIZVODE NECEMO NI KORISTITI DECODING

